import {
  useCreateTour,
  useGetTour,
} from 'api-hooks/tour/tour-list/tour-detail';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import LoadingComponent from 'components/common/loading';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { DetailContainer } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import * as React from 'react';
import { NavigationProps } from 'types';

import TourForm from './components/form';
import { TourListFormType } from './components/form-type';

export type TourViewParams = {
  id: string;
  defaultValues?: TourListFormType;
};

export default function TourView(
  props: NavigationProps<NavigationRoutes.TourView>,
) {
  const { query } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, isFetching, refetch } = useGetTour({
    id,
  });

  const { mutateAsync: mutateTour, error: errorMutateTour } = useCreateTour();

  const tour = data?.data;

  const onResolve = useApprovalableEdit('tours');

  return (
    <FetchWrapperComponent
      onRetry={refetch}
      loadingComponent={<LoadingComponent />}
      error={error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={refetch} />
        </DetailContainer>
      }
      isLoading={isLoading || isFetching}
      component={
        <>
          {!!errorMutateTour && !!errorMutateTour.message && (
            <>
              <Notification
                overrides={{
                  Body: { style: { width: 'auto', wordBreak: 'break-all' } },
                }}
                kind={KIND.negative}
                closeable
              >
                {() => errorMutateTour.message}
              </Notification>
            </>
          )}
          <TourForm
            {...props}
            tour={tour}
            onSubmit={async (input, form) => {
              const result = await mutateTour(input);
              onResolve(result);
              return result.data;
            }}
          />
        </>
      }
    />
  );
}
